// extracted by mini-css-extract-plugin
module.exports = {"container":"QuantityDropdown_container__2yGhz","min":"QuantityDropdown_min__1u1l6"};